<template>
	<div class="addzz">
		<el-dialog 
			:modal-append-to-body='true'
			width="600px"
			center
			:append-to-body='true'
			:visible.sync="feedWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					反馈
					<div class="addline"></div>
				</div>
			</div>
			<div class="databank">
				<el-input
				  type="textarea"
				  :rows="14"
				  resize="none"
				  placeholder="请输入内容"
				  v-model="value">
				</el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeFeed()">取 消</el-button>
			</div>
		</el-dialog>
		<div class="loading">
			
		</div>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dqgj } from '@/axios'
	let that;
	export default{
		data(){
			return{
				value:"",
				formData:{
					id:this.$route.query.id,
					user_id:this.$route.query.user_id,
					flag:this.$route.query.flag,
					type:4, //服务互助
					title:"",
					sz_img:"",
					source:"",
					class_id:"",
					url:"",
					content:"",
					feedback:'',
				}
			}
		},
		props:{
			feedWin:{
				type:Boolean,
				default:false
			},
			feedback:{
				type:String,
				default:""
			}
		},
		watch:{
			feedback(value){
				that.value = value
			}
		},
		created() {
			that = this;
		},
		methods:{
			submit(){
				that.formData.feedback = that.value;
				if(that.formData.feedback !=''){
					dqgj.dqgjUpdate(that.formData).then(res => {
						if(res.code == 200){
							Message({
								type:"success",
								message:"成功"
							})
							that.closeFeed();
						}else{
							Message({
								type:"error",
								message:res.msg
							})
						}
					})
				}else{
					Message({
						type:"error",
						message:"请输入反馈信息"
					})
				}
			},
			closeFeed(){
				that.$emit("closeFeed")
			}
		}
	}
</script>

<style>
	
</style>
